/* ===============================
   STICKY ADD TO CART
   =============================== */
document.addEventListener('scroll', () => {
  const form = document.querySelector('product-form form');
  const bar = document.getElementById('sticky-atc');
  if(!form || !bar) return;
  const r = form.getBoundingClientRect();
  const visible = r.top < window.innerHeight && r.bottom > 0;
  bar.style.bottom = visible ? '-120px' : '0';
});

/* ===============================
   FAQ ACCORDION
   =============================== */
document.querySelectorAll('.cuc-accordion .acc').forEach(btn=>{
  btn.addEventListener('click', ()=>{
    const panel = btn.nextElementSibling;
    panel.style.display = panel.style.display === 'block' ? 'none' : 'block';
  });
});

/* ===============================
   BACK TO TOP BUTTON
   =============================== */
const bt=document.getElementById('backTop');
window.addEventListener('scroll', ()=>{
  if(bt) bt.style.display = window.scrollY>600 ? 'block' : 'none';
});
bt?.addEventListener('click', ()=>window.scrollTo({top:0, behavior:'smooth'}));
/* ===============================
   CookUpCurls Custom Scripts
   =============================== */

/* Fade In on Load */
window.addEventListener('load', () => {
  document.body.classList.add('loaded');
});

/* Reveal Elements on Scroll */
window.addEventListener('scroll', () => {
  document.querySelectorAll('.reveal').forEach(el => {
    if (el.getBoundingClientRect().top < window.innerHeight - 100) {
      el.classList.add('active');
    }
  });
});

/* ===============================
   Before/After Slider Script
   =============================== */
document.querySelectorAll('.ba-container').forEach(container => {
  const overlay = container.querySelector('.ba-overlay');
  const handle = container.querySelector('.ba-handle');
  let isDown = false;

  const slide = (x) => {
    const rect = container.getBoundingClientRect();
    let offsetX = Math.max(0, Math.min(x - rect.left, rect.width));
    overlay.style.width = offsetX + "px";
    handle.style.left = offsetX + "px";
  };

  handle.addEventListener('mousedown', () => { isDown = true; });
  window.addEventListener('mouseup', () => { isDown = false; });
  window.addEventListener('mousemove', e => { if (isDown) slide(e.clientX); });

  // Touch support
  handle.addEventListener('touchstart', () => { isDown = true; });
  window.addEventListener('touchend', () => { isDown = false; });
  window.addEventListener('touchmove', e => { if (isDown) slide(e.touches[0].clientX); });
});
